// extracted by css-extract-rspack-plugin
export default {"root":"root-1_RbD","targetLink":"targetLink-MhiI4","content":"content-1B1qs","eyebrow":"eyebrow-pOPbZ"};